import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { withTooltip } from "../../hoc";
import { IconButtonStyled } from "./styled";

const IconButton = ({ hasHoverCircle, isLarge, hoverIcon, children, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);

  const buttonRef = useRef();
  const showHoverIcon = () => {
    setIsHovered(true);
  };

  const hideHoverIcon = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.addEventListener("mousemove", showHoverIcon);
      buttonRef.current.addEventListener("mouseleave", hideHoverIcon);
    }

    return () => {
      if (buttonRef && buttonRef.current) {
        buttonRef.current.removeEventListener("mousemove", showHoverIcon);
        buttonRef.current.removeEventListener("mouseleave", hideHoverIcon);
      }
    };
  }, []);

  return (
    <IconButtonStyled ref={buttonRef} hasHoverCircle={hasHoverCircle} isLarge={isLarge} {...props}>
      {hoverIcon && isHovered ? hoverIcon : children}
    </IconButtonStyled>
  );
};

IconButton.propTypes = {
  hasHoverCircle: PropTypes.bool,
  isLarge: PropTypes.bool,
  hoverIcon: PropTypes.node,
  children: PropTypes.node.isRequired
};

export default withTooltip(IconButton);
